<template>
    <div class="container-fluid">
        <div class="row">
            <!-- <header-vpos></header-vpos> -->
            <header class="p-0">
                <label for="toggle-1" class="toggle-menu" @click="toggleMenu">
                    <ul>
                        <li></li>
                        <li></li>
                        <li></li>
                    </ul>
                </label>
                <!-- <strong @click="toggleMenu"> &#9776;	</strong> -->
                <nav class="nav_center" style="padding: 0" :style="{ display: isMenuVisible ? 'block' : 'none' }">
                    <ul style="list-style: none">

                        <li :class="{ topmenuactive: activeTab === 'vimass' }" @click="changeTab('vimass')">
                            <a id="urlVimass" href="taichinhtoandien#taichinhtoandien/">{{
                                currentLanguage.header_text_Taichinhtoandien }}</a>
                        </li>
                        <li :class="{ topmenuactive: activeTab === 'Hanoi' }" @click="changeTab('Hanoi')">
                            <a id="urlBai2" href="taichinhtoandien#hanoi/">{{
                                currentLanguage.header_text_Hanoi
                                }}</a>
                        </li>
                        <li :class="{ topmenuactive: activeTab === 'quangtri' }" @click="changeTab('quangtri')">
                            <a id="urlPos" href="taichinhtoandien#quangtri">{{
                                currentLanguage.header_text_QuangTri
                                }}</a>
                        </li>
                        <li :class="{ topmenuactive: activeTab === 'ThietBi' }" @click="changeTab('ThietBi')">
                            <a id="urlThietBi" href="taichinhtoandien#danang/">{{
                                currentLanguage.header_text_DaNang
                                }}</a>
                        </li>


                        <li :class="{ topmenuactive: activeTab === 'dichvuthuchiho' }"
                            @click="changeTab('dichvuthuchiho')">
                            <a id="urlGiaoThong" href="taichinhtoandien#dichvuthuchiho">
                                {{  currentLanguage.header_text_thuChiHo }}</a>
                        </li>
                        <li :class="{ topmenuactive: activeTab === 'gioiThieu' }" @click="changeTab('gioiThieu')">
                            <a id="urlGioithieu" href="taichinhtoandien#dichvuthuho/">{{
                                currentLanguage.header_text_DVnganHang }}</a>
                        </li>
                        <!-- <li :class="{ topmenuactive: activeTab === 'dichvuthuchiho' }"
                            @click="changeTab('dichvuthuchiho')">
                            <a id="urlGiaoThong" href="taichinhtoandien#dichvuthuchiho">
                                Dịch vụ ngân hàng</a>
                        </li> -->

                        <li :class="{ topmenuactive: activeTab === 'taichinhtoandien' }"
                            @click="changeTab('taichinhtoandien')">
                            <a id="urlTaichinhtoandien" href="taichinhtoandien#taichinhbaohiem">
                                {{ currentLanguage.header_text_TaiChinhBaoHiem }}
                            </a>
                        </li>
                        <li :class="{ topmenuactive: activeTab === 'thanhtoanoffline' }"
                            @click="changeTab('thanhtoanoffline')">
                            <a id="urlThanhtoanoffline" href="taichinhtoandien#thanhtoanoffline">
                                {{ currentLanguage.header_text_qrThanhToan }} Offline
                            </a>
                        </li>
                        <!-- <li :class="{ topmenuactive: activeTab === 'taichinhtoandien' }" 
                            @click="changeTab('taichinhtoandien')" style="display: none;">
                            <a id="urlTaichinhtoandien" href="taichinhtoandien#taichinhtoandien">
                                {{ currentLanguage.item_footer_0 }}
                            </a>
                        </li> -->

                        <li :class="{ topmenuactive: activeTab === 'AIchotruonghoc' }"
                            @click="changeTab('AIchotruonghoc')">
                            <a id="urlBai1" href="taichinhtoandien#AIchotruonghoc/">{{
                                currentLanguage.header_text_AiTruongHoc }}</a>
                        </li>

                        <li :class="{ topmenuactive: activeTab === 'vivimass' }" @click="changeTab('vivimass')">
                            <a id="urlYte" href="taichinhtoandien#vivimass">
                                {{
                                    currentLanguage.header_text_ungDung_viVimass
                                }}
                            </a>
                        </li>
                        <li :class="{ topmenuactive: activeTab === 'dichvucongthongminh' }"
                            @click="changeTab('dichvucongthongminh')">
                            <a id="urlDVC" href="taichinhtoandien#thevimass">
                                {{ currentLanguage.header_text_phoCapThe }}</a>
                        </li>

                        <li :class="{ topmenuactive: activeTab === 'Quangtri' }" @click="changeTab('Quangtri')"
                            style="display: none">
                            <a id="Quangtri" href="taichinhtoandien#hopdong/">{{
                                currentLanguage.body_HopDong_text_title }} API</a>
                        </li>

                        <li :class="{ topmenuactive: activeTab === 'MayChu' }" @click="changeTab('MayChu')">
                            <a id="urlMayChu" href="taichinhtoandien#MayChu/">{{
                                currentLanguage.header_text_ungDung_mayChu15xa
                            }}</a>
                        </li>

                        <li :class="{ topmenuactive: activeTab === 'maychuvimass' }" @click="changeTab('maychuvimass')">
                            <a id="maychuvimass" href="taichinhtoandien#maychuvimass/">{{
                                currentLanguage.header_text_ungDung_mayChuVimass
                            }}</a>
                        </li>

                        <li :class="{ topmenuactive: activeTab === 'DichVu' }" style="display: none;"
                            @click="changeTab('DichVu')">
                            <a id="urlDichVu" href="taichinhtoandien#DichVu/">{{
                                currentLanguage.footer_text_dichVu
                                }}</a>
                        </li>

                        <li :class="{ topmenuactive: activeTab === 'LienHe' }" @click="changeTab('LienHe')">
                            <a id="urlBai6" href="taichinhtoandien#LienHe/">{{
                                currentLanguage.header_text_lienHe
                                }}</a>
                        </li>
                    </ul>
                </nav>
                <div class="menu_right" style="display: flex">
                    <a @click="changeLanguage('vi')" class="lang" style="padding: 5px"><img
                            src="img/img-item-vimass-2022/co/vi-VN.gif" />
                    </a>
                    <a @click="changeLanguage('en')" class="lang" style="padding: 5px"><img style="width: 25px"
                            src="img/img-item-vimass-2022/co/us.png" />
                    </a>
                    <a @click="changeLanguage('cn')" class="lang d-none" style="padding: 5px"><img style="width: 25px"
                            src="img/img-item-vimass-2022/co/cn.jpg" />
                    </a>
                    <a @click="changeLanguage('kr')" class="lang d-none" style="padding: 5px"><img style="width: 25px"
                            src="img/img-item-vimass-2022/co/kr.jpg" />
                    </a>
                    <a @click="changeLanguage('ja')" class="lang d-none" style="padding: 5px">
                        <img style="width: 25px" src="img/img-item-vimass-2022/co/ja.jpg" />
                    </a>

                    <!-- <a onclick="changeLang('hi')" class="lang"
            ><img style="width: 25px" src="img/img-item-vimass-2022/co/hi.png" />
          </a> -->
                    <span class="clickShow" style="color: #ffffff; cursor: pointer; margin: auto; padding: 5px"><i
                            class="fa fa-ellipsis-h" aria-hidden="true"></i></span>
                    <div class="showCo" style="display: none; margin: auto">
                        <a onclick="changeLang('us')" class="lang"><img src="img/img-item-vimass-2022/co/indo.jpg" />
                        </a>
                        <a onclick="changeLang('us')" class="lang"><img src="img/img-item-vimass-2022/co/tl.png" />
                        </a>
                        <a onclick="changeLang('us')" class="lang"><img src="img/img-item-vimass-2022/co/thailan.png" />
                        </a>
                        <a onclick="changeLang('us')" class="lang"><img src="img/img-item-vimass-2022/co/hu.jpg" />
                        </a>
                    </div>
                    <a id="urlHome" href="/" style="margin: 0 10px"><img style="width: 35px; height: 35px"
                            src="img/home-icon-white-8.jpg" />
                    </a>
                </div>
            </header>
            <div class="col-12 col-md-12">
                <div class="container-fluid p-2">
                    <div class="row">

                        <div v-show="showThietBi" class="min-h--500p" style="height: 600px;">
                            <!-- <MainThietBiVue /> -->
                            Đang cập nhật...
                        </div>

                        <div v-show="showPhi" class="min-h--500p">
                            <PhiDichVuVer2 />
                        </div>
                        <!-- <SearchStore v-if="phoneSearch"></SearchStore> -->
                        <div id="thanhtoanoffline" v-show="showThanhtoanoffline" style="min-height: 500px"
                            class="padding-top15">
                            <div class="title-bai-viet" v-html="titleThanhtoanoffline"></div>
                            <div v-html="contentThanhtoanoffline" style="text-align: start"></div>
                        </div>
                        <div id="gioiThieu" v-show="showGioiThieu" style="min-height: 500px" class="padding-top15">
                            <div class="title-bai-viet" v-html="titleGioiThieu"></div>
                            <div v-html="contentGioiThieu" style="text-align: start"></div>
                        </div>
                        <div id="dichvuthuchiho" v-show="showGiaoThong" style="min-height: 500px" class="padding-top15">
                            <div class="title-bai-viet" v-html="titleGiaoThong"></div>
                            <div v-html="contentGiaoThong" style="text-align: start"></div>
                        </div>
                        <div id="dichvucong" v-show="showDichVuCong" style="min-height: 500px" class="padding-top15">
                            <div class="title-bai-viet" v-html="titleDichVuCong"></div>
                            <div v-html="contentDichVuCong" style="text-align: start"></div>
                        </div>
                        <div id="yte" v-show="showYte" style="min-height: 500px" class="padding-top15">
                            <div class="title-bai-viet" v-html="titleYte"></div>
                            <div v-html="contentYte" style="text-align: start"></div>
                        </div>
                        <div id="Quangtri" v-show="showQuangtri"
                            style="min-height: 500px; background-image: none !important" class="padding-top15">
                            <div class="title-bai-viet" v-html="titleQuangtri" style="text-align: start"></div>
                            <div v-html="contentQuangtri" style="text-align: start"></div>
                        </div>
                        <!-- Hanoi -->

                        <div id="vimass" v-show="showVimass"
                            style="min-height: 500px; background-image: none !important" class="padding-top15">
                            <div class="title-bai-viet" v-html="titleVimass"></div>
                            <div v-html="contentVimass"></div>
                            <!-- <img-app-vimass></img-app-vimass> -->
                        </div>
                        <div id="Hanoi" v-show="showHanoi" style="min-height: 500px; background-image: none !important"
                            class="padding-top15">
                            <div class="title-bai-viet" v-html="titleHanoi"></div>
                            <div v-html="contentHanoi" style="text-align: start; font-size: 14px;"></div>
                        </div>
                        <div id="taichinhtoandien" v-show="showTaichinhtoandien"
                            style="min-height: 500px; background-image: none !important">
                            <div class="title-bai-viet" v-html="titleTaichinhtoandien"></div>
                            <div v-html="contentTaichinhtoandien" style="text-align: start"></div>
                        </div>

                        <div id="quangtri" v-show="showPos"
                            style="min-height: 500px; background-image: none !important">
                            <div class="title-bai-viet" v-html="titlePos"></div>
                            <div v-html="contentPos" style="text-align: start"></div>
                            <!-- Đang cập nhật... -->
                        </div>
                        <div v-show="isActiveMayChu" style="min-height: 500px">
                            <!-- <MayChu></MayChu> -->
                            <!-- <MainDinhDanhXacThuc> </MainDinhDanhXacThuc> -->
                            <div v-html="titleHtmlMayChu" class="title-bai-viet"></div>
                            <div v-html="contentHtmlMayChu"></div>
                        </div>
                        <div v-show="isActiveMayChuVimass" style="min-height: 500px">
                            <!-- <MayChu></MayChu> -->
                            <!-- <MainDinhDanhXacThuc> </MainDinhDanhXacThuc> -->
                            <div v-html="titleHtmlMayChuVimass" class="title-bai-viet"></div>
                            <div v-html="contentHtmlMayChuVimass"></div>
                        </div>
                        <div id="aIchotruonghoc" v-show="showAIchotruonghoc"
                            style="min-height: 500px; background-image: none !important">
                            <div class="title-bai-viet" v-html="titleAIchotruonghoc"></div>
                            <div v-html="contentAIchotruonghoc" style="text-align: start"></div>
                            <!-- <div class="container-fluid">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <div class="card dark" style="margin: 1em auto; max-width: 60em" v-for="(itemLinhVuc, index) in items.slice(
                      0,
                      Math.ceil(items.length / 2)
                    )" :key="index">
                      <a :href="itemLinhVuc.url !== '#' ? itemLinhVuc.url : null" target="__blank">
                        <div class="d-flex">
                          <img style="width: 15%" :src="itemLinhVuc.imgLinhVuc" class="card-img-top" />

                          <div class="card-body">
                            <div class="text-section m-auto d-flex flex-column">
                              <h5 class="card-title" style="color: black">
                                {{ itemLinhVuc.title }}
                              </h5>
                              <p class="card-text" style="color: black; line-height: 1.3">
                                {{ itemLinhVuc.moTa }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>

                  <div class="col-12 col-md-6">
                    <div class="card dark" style="margin: 1em auto; max-width: 60em" v-for="(itemLinhVuc, index) in items.slice(
                      Math.ceil(items.length / 2)
                    )" :key="index">
                      <a :href="itemLinhVuc.url !== '#' ? itemLinhVuc.url : null" target="__blank">
                        <div class="d-flex">
                          <img style="width: 15%" :src="itemLinhVuc.imgLinhVuc" class="card-img-top" />

                          <div class="card-body">
                            <div class="text-section m-auto d-flex flex-column">
                              <h5 class="card-title" style="color: black">
                                {{ itemLinhVuc.title }}
                              </h5>
                              <p class="card-text" style="color: black; line-height: 1.3">
                                {{ itemLinhVuc.moTa }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div> -->
                        </div>
                        <div id="lienhe" v-show="showLienHe"
                            style="min-height: 500px; background-image: none !important">
                            <!-- <div class="title-bai-viet" v-html="titleLienHe"></div> -->
                            <div v-html="contentLienHe" style="text-align: start"></div>
                        </div>
                        <ul class="mt-3" v-if="riengChecked">
                            <li v-for="store in listCuaHang" :key="store.id" class="p-2">
                                <div class="w-100 p-3" style="
                    height: 45px;
                    background-color: rgb(239 239 239);
                    border-radius: 10px;
                    border-bottom: 2px rgb(185 185 185) solid;
                    text-align: start;
                    cursor: pointer;
                  ">
                                    <span style="font-weight: 600; margin-left: 20px">{{ store.storeName }}
                                    </span>
                                    | <span> {{ store.storeAdd }}</span>
                                </div>
                            </li>
                        </ul>
                        <div class="m-auto" v-if="chungChecked"></div>
                        <CreateStore class="d-none"></CreateStore>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <FooterView></FooterView>
</template>

<script>
import { imageUrls } from "@/components/js/urlImg";
import MainThietBiVue from "../MainBaiVietCon/ThietBiVaDichVu/MainThietBi.vue";
import PhiDichVuVer2 from "../MainBaiVietCon/ThietBiVaDichVu/DichVu/PhiDichVuVer2.vue";

import { languages } from "@/components/languages";
import { postLayTiGia } from "@/components/js/VposServiceDanh";
import axios from "axios";
import { apiChiTietBaiViet } from "@/components/listService";
import FooterView from "@/views/Vimass/Footer/FooterView.vue";

export default {
    components: {
        // eslint-disable-next-line vue/no-unused-components
        FooterView, MainThietBiVue, PhiDichVuVer2
    },
    data() {
        return {
            activeTab: "dichvuthuchiho",
            isMenuVisible: false,
            imageUrls: imageUrls,
            currentLanguage: languages.vi,
            Login: false,
            menuThongTin: false,
            register: false,
            user: "",
            listCuaHang: [],
            bannerQuangCao: true,
            phoneSearch: true,
            slideWeb: true,
            activeThietBi: false,
            showThietBi: false,
            activePhi: false,
            showPhi: false,

            showTaichinhtoandien: false,
            isActiveTaichinhtoandien: false,

            showGiaoThong: true,
            isActiveGiaoThong: true,

            showDichVuCong: false,
            isActiveDichVuCong: false,

            showYte: false,
            isActiveYte: false,

            showAIchotruonghoc: false,
            isActiveAIchotruonghoc: false,

            showLienHe: false,
            isActiveLienHe: false,

            showPos: false,
            isActivePos: false,

            showVimass: false,
            isActiveVimass: false,

            showThanhtoanoffline: false,
            isActiveThanhtoanoffline: false,

            titleVimass: "",
            contentVimass: "",

            titleThanhtoanoffline: "",
            contentThanhtoanoffline: "",

            titlePos: "",
            contentPos: "",
            titleTaichinhtoandien: "",
            contentTaichinhtoandien: "",
            titleLienHe: "",
            contentLienHe: "",
            titleAIchotruonghoc: "",
            contentAIchotruonghoc: "",

            titleGiaoThong: "",
            contentGiaoThong: "",

            titleDichVuCong: "",
            contentDichVuCong: "",

            titleYte: "",
            contentYte: "",

            //show
            showGioiThieu: false,
            showQuangtri: false,
            showHanoi: false,

            //active tab
            isActiveGioiThieu: false,
            isActiveQuangtri: false,
            isActiveHanoi: false,

            //title
            titleGioiThieu: "",
            titleQuangtri: "",
            titleHanoi: "",

            //content
            contentGioiThieu: "",
            contentQuangtri: "",
            contentHanoi: "",
            showMayChu: false,

            isActiveMayChu: false,

            titleHtmlMayChu: "",
            contentHtmlMayChu: "",

            showMayChuVimass: false,
            isActiveMayChuVimass: false,

            titleHtmlMayChuVimass: "",
            contentHtmlMayChuVimass: "",
            docId: "1TGA7zcPFDEqr0JcSZUxadu7EMPuFwgJo", // ID của tài liệu Google Docs
            embeddedUrl: "",

            items: [],
        };
    },
    created() {
        const savedLanguage = localStorage.getItem("languages") || "vi";
        if (savedLanguage && languages[savedLanguage]) {
            this.currentLanguage = languages[savedLanguage];
        }
    },
    mounted() {
        this.fetchData();
        if (window.innerWidth <= 768) {
            this.isMenuVisible = false;
        } else {
            this.isMenuVisible = true;
        }
        if (!this.hasMounted) {
            this.hasMounted = true; // Set the flag to true to indicate that mounted has been executed
            this.lang = localStorage.getItem("languages") || "vi";
            if (this.lang == "vi") {
                document.title = "Vimass.vn - Tài chính toàn diện";
            } else if (this.lang == "en") {
                document.title = "Vimass.vn - Smart payment";
            } else if (this.lang == "cn") {
                document.title = "Vimass.vn - Vimass AI Editor";
            } else if (this.lang == "kr") {
                document.title = "Vimass.vn - Vimass AI Editor";
            }
            this.checkUrl();

            this.performPostRequest(
                "1769659637577jpn8C",
                "dichvuthuchiho",
                this.lang
            );
            document.getElementById("urlHome").setAttribute("href", this.lang);
            document
                .getElementById("urlPos")
                .setAttribute("href", this.lang + "/taichinhtoandien#quangtri/");
            document
                .getElementById("urlTaichinhtoandien")
                .setAttribute(
                    "href",
                    this.lang + "/taichinhtoandien#taichinhbaohiem/"
                );
            document
                .getElementById("urlBai1")
                .setAttribute("href", this.lang + "/taichinhtoandien#aichotruonghoc/");
            document
                .getElementById("urlBai6")
                .setAttribute("href", this.lang + "/taichinhtoandien#lienhe/");
            document
                .getElementById("urlVimass")
                .setAttribute("href", this.lang + "/taichinhtoandien#taichinhbaohiem/");
            document
                .getElementById("urlGioithieu")
                .setAttribute("href", this.lang + "/taichinhtoandien#dichvuthuho/");
            document
                .getElementById("Quangtri")
                .setAttribute("href", this.lang + "/taichinhtoandien#hopdong/");
            document
                .getElementById("urlBai2")
                .setAttribute("href", this.lang + "/taichinhtoandien#hanoi/");
            document
                .getElementById("urlMayChu")
                .setAttribute("href", this.lang + "/taichinhtoandien#maychu/");
            document
                .getElementById("maychuvimass")
                .setAttribute("href", this.lang + "/taichinhtoandien#maychuvimass/");
            document
                .getElementById("urlGiaoThong")
                .setAttribute(
                    "href",
                    this.lang + "/taichinhtoandien#dichvuthuchiho/"
                );
            document
                .getElementById("urlDVC")
                .setAttribute(
                    "href",
                    this.lang + "/taichinhtoandien#thevimass/"
                );
            document
                .getElementById("urlYte")
                .setAttribute("href", this.lang + "/taichinhtoandien#vivimass/");
            document
                .getElementById("urlThanhtoanoffline")
                .setAttribute(
                    "href",
                    this.lang + "/taichinhtoandien#thanhtoanoffline/"
                );
            document
                .getElementById("urlThietBi")
                .setAttribute("href", this.lang + "/taichinhtoandien#danang");
            document
                .getElementById("urlDichVu")
                .setAttribute("href", this.lang + "/taichinhtoandien#dichvu");
            const hash = window.location.hash;
            if (hash && hash.includes("#quangtri")) {
                this.changeTab("quangtri");
            } else if (hash && hash.includes("#taichinhtoandien")) {
                this.changeTab("vimass");
                // this.changeTab("taichinhtoandien");
            } else if (hash && hash.includes("#aichotruonghoc")) {
                this.changeTab("AIchotruonghoc");
            } else if (hash && hash.includes("#lienhe")) {
                this.changeTab("LienHe");
            } else if (hash && hash.includes("#dichvuthuho")) {
                this.changeTab("gioiThieu");
            } else if (hash && hash.includes("#hopdong")) {
                this.changeTab("Quangtri");
            } else if (hash && hash.includes("#vimass")) {
                this.changeTab("vimass");
            } else if (hash && hash.includes("#hanoi")) {
                this.changeTab("Hanoi");
            } else if (hash && hash.includes("#phocapthsinhtrachoc")) {
                this.changeTab("dichvuthuchiho");
            } else if (hash && hash.includes("#thevimass")) {
                this.changeTab("dichvucongthongminh");
            } else if (hash && hash.includes("#vivimass")) {
                this.changeTab("vivimass");
            } else if (hash && hash.includes("#thanhtoanoffline")) {
                this.changeTab("thanhtoanoffline");
            } else if (hash && hash.includes("#danang")) {
                this.changeTab("ThietBi");
            } else if (hash && hash.includes("#dichvu")) {
                this.changeTab("DichVu");
            } else if (hash && hash.includes("#maychu")) {
                this.changeTab("MayChu");
            } else if (hash && hash.includes("#maychuvimass")) {
                this.changeTab("maychuvimass");
            } else if (hash && hash.includes("#taichinhbaohiem")) {
                this.changeTab("taichinhtoandien");
            } else {
                this.changeTab("vimass");
            }
        }
        if (window.innerWidth <= 768) {
            this.isMenuVisible = false;
        } else {
            this.isMenuVisible = true;
        }
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.checkScreenSize);
    },
    methods: {
        checkUrl() {
            // if (window.location.href.indexOf("taichinhtoandien") > -1) {
            //   this.changeTab("taichinhtoandien"); // Gọi hàm changeTab với giá trị hash (vd: 'AIchotruonghoc')
            // } else {
            //   window.location.href = this.lang + "/taichinhtoandien#taichinhtoandien/";
            // } ??? tai sao lai fix url the nay ???
        },
        async fetchData() {
            this.apiUrl =
                "https://sheets.googleapis.com/v4/spreadsheets/1EArWilSVZmk23GG5AlCoVov-e1nbVdxbNdNTENzdFwQ/values/jsonUrlLinhVuc?key=AIzaSyB6KdsUEG02YYtkYDjFlVA-HrSvs_PULh4";

            try {
                const response = await axios.get(this.apiUrl);
                const lang = localStorage.getItem("languages") || "vi";

                this.items = response.data.values
                    .map((row) => {
                        if (row[4] && lang && row[4].trim() === lang.trim()) {
                            return {
                                title: row[0],
                                url: row[1],
                                imgLinhVuc: row[2],
                                moTa: row[3],
                            };
                        }
                    })
                    .filter((item) => item !== undefined);

                // console.log("this.items ", this.items);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        },

        changeLanguage(lang) {
            // this.currentLanguage = languages[lang];
            // localStorage.setItem("languages", lang);
            // window.location.reload();
            this.currentLanguage = languages[lang];
            localStorage.setItem("languages", lang);
            const langReload = localStorage.getItem("languages");
            window.location.href =
                "/" + langReload + "/taichinhtoandien" + window.location.hash;
        },
        async layTyGia() {
            await postLayTiGia();
        },

        handleDataReceived() {
            var data = localStorage.getItem("dataCuaHang");
            this.listCuaHang = JSON.parse(data);
        },
        async performPostRequest(id, section) {
            const path = window.location.pathname;
            this.lang = (path.split("/").filter(Boolean)[0] || "vi").slice(0, 2);
            console.log("this.lang", this.lang);

            try {
                // Thực hiện POST request
                const response = await axios.post(apiChiTietBaiViet, {
                    id: id,
                    langId: "0",
                });
                if (this.lang === "vi") {
                    this.base64 = response.data.result.content_vi;
                    this.base64Title = response.data.result.title_vi;
                } else if (this.lang === "en") {
                    this.base64 = response.data.result.content_en;
                    this.base64Title = response.data.result.title_en;
                } else if (this.lang === "cn") {
                    this.base64 = response.data.result.content_cn;
                    this.base64Title = response.data.result.title_cn;
                } else if (this.lang === "kr") {
                    this.base64 = response.data.result.content_kr;
                    this.base64Title = response.data.result.title_kr;
                } else {
                    this.base64 = response.data.result.content_vi;
                    this.base64Title = response.data.result.title_vi;
                }

                var title = atob(this.base64Title);
                var decodedString = atob(this.base64);

                // Store content separately for each section

                if (section === "gioiThieu") {
                    this.titleGioiThieu = decodeURIComponent(escape(title));
                    this.contentGioiThieu = decodeURIComponent(escape(decodedString));
                } else if (section === "Quangtri") {
                    this.titleQuangtri = decodeURIComponent(escape(title));
                    this.contentQuangtri = decodeURIComponent(escape(decodedString));
                } else if (section === "Hanoi") {
                    this.titleHanoi = decodeURIComponent(escape(title));
                    this.contentHanoi = decodeURIComponent(escape(decodedString));
                } else if (section === "quangtri") {
                    this.titlePos = decodeURIComponent(escape(title));
                    this.contentPos = decodeURIComponent(escape(decodedString));
                } else if (section === "taichinhtoandien") {
                    this.titleTaichinhtoandien = decodeURIComponent(escape(title));
                    this.contentTaichinhtoandien = decodeURIComponent(
                        escape(decodedString)
                    );
                } else if (section === "AIchotruonghoc") {
                    this.titleAIchotruonghoc = decodeURIComponent(escape(title));
                    this.contentAIchotruonghoc = decodeURIComponent(escape(decodedString));
                } else if (section === "LienHe") {
                    this.titleLienHe = decodeURIComponent(escape(title));
                    this.contentLienHe = decodeURIComponent(escape(decodedString));
                } else if (section === "vimass") {
                    this.titleVimass = decodeURIComponent(escape(title));
                    this.contentVimass = decodeURIComponent(escape(decodedString));
                } else if (section === "dichvuthuchiho") {
                    this.titleGiaoThong = decodeURIComponent(escape(title));
                    this.contentGiaoThong = decodeURIComponent(escape(decodedString));
                } else if (section === "dichvucongthongminh") {
                    this.titleDichVuCong = decodeURIComponent(escape(title));
                    this.contentDichVuCong = decodeURIComponent(escape(decodedString));
                } else if (section === "vivimass") {
                    this.titleYte = decodeURIComponent(escape(title));
                    this.contentYte = decodeURIComponent(escape(decodedString));
                } else if (section === "thanhtoanoffline") {
                    this.titleThanhtoanoffline = decodeURIComponent(escape(title));
                    this.contentThanhtoanoffline = decodeURIComponent(
                        escape(decodedString)
                    );
                } else if (section === "MayChu") {
                    this.titleHtmlMayChu = decodeURIComponent(escape(title));
                    this.contentHtmlMayChu = decodeURIComponent(escape(decodedString));
                }
                else if (section === "maychuvimass") {
                    this.titleHtmlMayChuVimass = decodeURIComponent(escape(title));
                    this.contentHtmlMayChuVimass = decodeURIComponent(escape(decodedString));
                }
                // else if (section === "congTacVien") {
                //   this.titleCongTacVien = decodeURIComponent(escape(title));
                //   this.contentCongTacVien = decodeURIComponent(escape(decodedString));
                // }
                // else if (section === "HuongDan") {
                //   this.titleHuongDan = decodeURIComponent(escape(title));
                //   this.contentHuongDan = decodeURIComponent(escape(decodedString));
                // }
            } catch (error) {
                console.error("Error:", error);
            }
        },

        toggleMenu() {
            this.isMenuVisible = true;
        },
        changeTab(tab) {
            if (window.innerWidth <= 768) {
                this.isMenuVisible = false;
            }
            this.lang = localStorage.getItem("languages") || "vi";

            if (tab === "taichinhtoandien") {
                this.isActivePos = false;
                this.isActiveTaichinhtoandien = true;
                this.isActiveAIchotruonghoc = false;
                this.isActiveLienHe = false;
                this.isActiveVimass = false;
                this.isActiveHanoi = false;
                this.isActiveQuangtri = false;
                this.isActiveDichVuCong = false;
                this.isActiveGiaoThong = false;
                this.isActiveThanhtoanoffline = false;
                this.isActiveYte = false;
                this.activeThietBi = false;
                this.activePhi = false;
                this.isActiveMayChu = false;
                this.isActiveMayChuVimass = false;
                this.performPostRequest(
                    "1769754280689Pi798",
                    "taichinhtoandien",
                    this.lang
                );
                // this.performPostRequest("17459097045371VwAU", "taichinhtoandien", this.lang); //taichinhtoandien
            } else if (tab === "quangtri") {
                this.isActivePos = true;
                this.isActiveTaichinhtoandien = false;
                this.isActiveAIchotruonghoc = false;
                this.isActiveLienHe = false;
                this.isActiveVimass = false;
                this.isActiveDichVuCong = false;
                this.isActiveGiaoThong = false;
                this.isActiveThanhtoanoffline = false;
                this.isActiveYte = false;
                this.activeThietBi = false; this.isActiveMayChu = false;
                this.isActiveMayChuVimass = false;
                this.activePhi = false;
                this.performPostRequest(
                    "1769595832870vyw8t",
                    "quangtri",
                    this.lang
                );
            } else if (tab === "AIchotruonghoc") {
                this.isActivePos = false;
                this.isActiveTaichinhtoandien = false;
                this.isActiveAIchotruonghoc = true;
                this.isActiveHanoi = false;
                this.isActiveQuangtri = false;
                this.isActiveLienHe = false;
                this.isActiveVimass = false;
                this.isActiveThanhtoanoffline = false;
                this.isActiveDichVuCong = false; this.isActiveMayChu = false;
                this.isActiveMayChuVimass = false;
                this.isActiveGiaoThong = false;
                this.isActiveYte = false;
                this.activeThietBi = false;
                this.activePhi = false;
                this.performPostRequest("1741150321722AwaTo", "AIchotruonghoc", this.lang);
            } else if (tab === "LienHe") {
                this.isActivePos = false;
                this.isActiveTaichinhtoandien = false;
                this.isActiveAIchotruonghoc = false;
                this.isActiveHanoi = false;
                this.isActiveQuangtri = false;
                this.isActiveLienHe = true;
                this.isActiveVimass = false;
                this.isActiveDichVuCong = false;
                this.isActiveGiaoThong = false;
                this.isActiveThanhtoanoffline = false;
                this.isActiveYte = false;
                this.activeThietBi = false; this.isActiveMayChu = false;
                this.isActiveMayChuVimass = false;
                this.activePhi = false;
                this.performPostRequest("1690272053288yg3c7", "LienHe", this.lang);
            } else if (tab === "gioiThieu") {
                this.isActivePos = false;
                this.isActiveTaichinhtoandien = false;
                this.isActiveAIchotruonghoc = false;
                this.isActiveGioiThieu = true;
                this.isActiveQuangtri = false;
                this.isActiveHanoi = false;
                this.isActiveDichVuCong = false;
                this.isActiveGiaoThong = false;
                this.isActiveThanhtoanoffline = false;
                this.isActiveYte = false;
                this.isActiveLienHe = false;
                this.isActiveVimass = false;
                this.activeThietBi = false; this.isActiveMayChu = false;
                this.isActiveMayChuVimass = false;
                this.activePhi = false;
                this.performPostRequest("17697543313580GMHl", "gioiThieu", this.lang);
            } else if (tab === "Quangtri") {
                this.isActiveGioiThieu = false;
                this.isActivePos = false;
                this.isActiveTaichinhtoandien = false;
                this.isActiveAIchotruonghoc = false;
                this.isActiveQuangtri = true;
                this.isActiveHanoi = false;
                this.isActiveDichVuCong = false;
                this.isActiveThanhtoanoffline = false;
                this.isActiveGiaoThong = false;
                this.isActiveYte = false;
                this.isActiveLienHe = false;
                this.isActiveVimass = false;
                this.activeThietBi = false; this.isActiveMayChu = false;
                this.isActiveMayChuVimass = false;
                this.activePhi = false;
                this.performPostRequest(
                    "17412528497024i7x3",
                    "Quangtri",
                    this.lang
                );
            } else if (tab === "vimass") {
                this.isActiveGioiThieu = false;
                this.isActivePos = false;
                this.isActiveTaichinhtoandien = false;
                this.isActiveAIchotruonghoc = false;
                this.isActiveQuangtri = false;
                this.isActiveHanoi = false;
                this.isActiveDichVuCong = false;
                this.isActiveThanhtoanoffline = false;
                this.isActiveGiaoThong = false;
                this.isActiveYte = false;
                this.isActiveLienHe = false;
                this.isActiveVimass = true;
                this.activeThietBi = false; this.isActiveMayChu = false;
                this.isActiveMayChuVimass = false;
                this.activePhi = false;
                this.performPostRequest("176959473644398L7y", "vimass", this.lang);
            } else if (tab === "Hanoi") {
                this.isActiveHanoi = true;
                this.isActiveGioiThieu = false;
                this.isActivePos = false;
                this.isActiveTaichinhtoandien = false;
                this.isActiveAIchotruonghoc = false;
                this.isActiveDichVuCong = false;
                this.isActiveGiaoThong = false;
                this.isActiveThanhtoanoffline = false;
                this.isActiveYte = false;
                this.isActiveQuangtri = false;
                this.isActiveLienHe = false;
                this.activeThietBi = false;
                this.activePhi = false;
                this.isActiveVimass = false; this.isActiveMayChu = false;
                this.isActiveMayChuVimass = false;
                this.performPostRequest(
                    "1769595754694WoRRS",
                    "Hanoi",
                    this.lang
                );
            } else if (tab === "dichvuthuchiho") {
                this.isActiveGioiThieu = false;
                this.isActivePos = false;
                this.isActiveTaichinhtoandien = false;
                this.isActiveAIchotruonghoc = false;
                this.isActiveThanhtoanoffline = false;
                this.isActiveQuangtri = false;
                this.isActiveHanoi = false;
                this.isActiveLienHe = false;
                this.isActiveVimass = false;
                this.isActiveDichVuCong = false;
                this.activeThietBi = false;
                this.activePhi = false;
                this.isActiveGiaoThong = true;
                this.isActiveYte = false; this.isActiveMayChu = false;
                this.isActiveMayChuVimass = false;
                this.performPostRequest(
                    "1769754433067RUshl",
                    "dichvuthuchiho",
                    this.lang);
                // this.performPostRequest(
                //     "1769659637577jpn8C",
                //     "dichvuthuchiho",
                //     this.lang
                // );
            } else if (tab === "dichvucongthongminh") {
                this.isActiveGioiThieu = false;
                this.isActivePos = false;
                this.isActiveTaichinhtoandien = false;
                this.isActiveAIchotruonghoc = false;
                this.isActiveQuangtri = false;
                this.isActiveHanoi = false;
                this.isActiveLienHe = false;
                this.isActiveVimass = false;
                this.activeThietBi = false;
                this.activePhi = false;
                this.isActiveDichVuCong = true;
                this.isActiveThanhtoanoffline = false;
                this.isActiveGiaoThong = false;
                this.isActiveYte = false; this.isActiveMayChu = false;
                this.isActiveMayChuVimass = false;
                this.performPostRequest(
                    "1546059256581d0h0r",
                    "dichvucongthongminh",
                    this.lang
                );
            } else if (tab === "vivimass") {
                this.isActiveGioiThieu = false;
                this.isActivePos = false;
                this.isActiveTaichinhtoandien = false;
                this.isActiveAIchotruonghoc = false;
                this.isActiveQuangtri = false;
                this.isActiveHanoi = false;
                this.isActiveThanhtoanoffline = false;
                this.isActiveLienHe = false;
                this.activeThietBi = false;
                this.activePhi = false;
                this.isActiveVimass = false;
                this.isActiveDichVuCong = false;
                this.isActiveGiaoThong = false;
                this.isActiveYte = true; this.isActiveMayChu = false;
                this.isActiveMayChuVimass = false;
                this.performPostRequest(
                    "17615495777926yVTI",
                    "vivimass",
                    this.lang
                );
            } else if (tab === "thanhtoanoffline") {
                this.isActiveGioiThieu = false;
                this.isActivePos = false;
                this.isActiveTaichinhtoandien = false;
                this.isActiveAIchotruonghoc = false;
                this.isActiveQuangtri = false;
                this.isActiveHanoi = false;
                this.isActiveGiaoThong = false;
                this.isActiveLienHe = false;
                this.isActiveVimass = false;
                this.activeThietBi = false;
                this.activePhi = false;
                this.isActiveDichVuCong = false;
                this.isActiveYte = false; this.isActiveMayChu = false;
                this.isActiveMayChuVimass = false;
                this.isActiveThanhtoanoffline = true;
                //id giao dich thong mimh : 1752641179197zG30M 
                this.performPostRequest(
                    "1769659765462k2r4M",
                    "thanhtoanoffline",
                    this.lang
                );

            } else if (tab === "MayChu") {
                this.isActiveGioiThieu = false;
                this.isActivePos = false;
                this.isActiveTaichinhtoandien = false;
                this.isActiveAIchotruonghoc = false;
                this.isActiveQuangtri = false;
                this.isActiveHanoi = false;
                this.isActiveGiaoThong = false;
                this.isActiveLienHe = false;
                this.isActiveVimass = false;
                this.activeThietBi = false;
                this.activePhi = false;
                this.isActiveDichVuCong = false;
                this.isActiveYte = false; this.isActiveMayChu = true;
                this.isActiveMayChuVimass = false;
                this.isActiveThanhtoanoffline = false;
                this.performPostRequest(
                    "1696472407793JGiel",
                    "MayChu",
                    this.lang
                );
            } else if (tab === "maychuvimass") {
                this.isActiveGioiThieu = false;
                this.isActivePos = false;
                this.isActiveTaichinhtoandien = false;
                this.isActiveAIchotruonghoc = false;
                this.isActiveQuangtri = false;
                this.isActiveHanoi = false;
                this.isActiveGiaoThong = false;
                this.isActiveLienHe = false;
                this.isActiveVimass = false;
                this.activeThietBi = false;
                this.activePhi = false;
                this.isActiveDichVuCong = false;
                this.isActiveYte = false;
                this.isActiveMayChu = false;
                this.isActiveMayChuVimass = true;

                this.isActiveThanhtoanoffline = false;
                this.performPostRequest(
                    "1710304613632p5sAE",
                    "maychuvimass",
                    this.lang
                );
            }



            this.activeTab = tab;
            this.showPos = tab === "quangtri";
            this.showTaichinhtoandien = tab === "taichinhtoandien";
            this.showAIchotruonghoc = tab === "AIchotruonghoc";
            this.showGioiThieu = tab === "gioiThieu";
            this.showQuangtri = tab === "Quangtri";
            this.showHanoi = tab === "Hanoi";
            this.showLienHe = tab === "LienHe";
            this.showVimass = tab === "vimass";
            this.showGiaoThong = tab === "dichvuthuchiho";
            this.showDichVuCong = tab === "dichvucongthongminh";
            this.showYte = tab === "vivimass";
            this.showThanhtoanoffline = tab === "thanhtoanoffline";
            this.showThietBi = tab === "ThietBi";
            this.showPhi = tab === "DichVu";
            this.showMayChu = tab === "MayChu";
            this.showMayChuVimass = tab === "maychuvimass";

        },
    },
};
</script>

<style scoped>
nav ul li a {
    color: #ffffff;
    font-size: 15px;
    padding: 12px 10px;
    display: inline-block;
    font-family: auto;
    font-weight: 400;
    transition: all 0.5s ease 0s;
    text-decoration: none !important;
}

.dropbtn {
    background-color: #007abb;
    color: white;
    border: none;
}

.dropdown {
    position: relative;
    display: inline-block;
}

.dropdown-content {
    display: none;
    position: absolute;
    background-color: #f1f1f1;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
}

.dropdown-content a {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
}

.dropdown:hover .dropdown-content {
    display: block;
}

.dropdown:hover .dropbtn {
    background-color: #007abb !important;
}

.card {
    max-width: 30em;
    flex-direction: row;
    background-color: #696969;
    border: 0;
    box-shadow: 0 7px 7px rgba(0, 0, 0, 0.18);
    margin: 3em auto;
}

.card.dark {
    color: #fff;
}

.card.card.bg-light-subtle .card-title {
    color: dimgrey;
}

.card img {
    max-width: 25%;
    margin: auto;
    padding: 0.5em;
    border-radius: 0.7em;
}

.card-body {
    display: flex;
    justify-content: space-between;
}

.text-section {
    max-width: 90%;
}

.cta-section {
    max-width: 40%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
}

.cta-section .btn {
    padding: 0.3em 0.5em;
    /* color: #696969; */
}

.card.bg-light-subtle .cta-section .btn {
    background-color: #898989;
    border-color: #898989;
}

.ytp-right-controls .ytp-subtitles-button {
    display: none !important;
}

/* iframe {
    pointer-events: none!important;;
} */

@media (min-width: 992px) {
    #taichinhtoandien .vdeoamthanh {
        width: 100% !important;
        display: flex;
        flex-wrap: nowrap;
    }

    #taichinhtoandien .vdeoamthanh .vdtrai {
        width: 32% !important;
    }

    #taichinhtoandien .vdeoamthanh .vdtrai iframe {
        max-width: 560px;
        width: 100%;
        margin: 0 auto;
        height: 320px;
    }

    #taichinhtoandien .vdeoamthanh .vdnoidung {
        width: 68% !important;
        margin-left: 3px;
    }

    #quangtri .vdeoamthanh {
        width: 100% !important;
        display: flex;
        flex-wrap: nowrap;
    }

    #quangtri .vdeoamthanh .vdtrai {
        width: 77% !important;
        margin-left: 3px;
    }

    #quangtri .vdeoamthanh .vdtrai iframe {
        max-width: 1440px;
        width: 100%;
        margin: 0 auto;
        height: 800px;
    }

    #quangtri .vdeoamthanh .vdnoidung {
        width: 22% !important;
        margin-left: 3px;
        font-size: 18px;
    }
}

@media (max-width: 991.99px) {
    #taichinhtoandien .vdeoamthanh {
        width: 100% !important;
        display: flex;
        flex-wrap: wrap;
    }

    #taichinhtoandien .vdeoamthanh .vdtrai {
        width: 100% !important;
    }

    #taichinhtoandien .vdeoamthanh .vdtrai iframe {
        width: 100%;
        height: 220px;
        max-width: 560px;
        margin: 0 auto;
    }

    #taichinhtoandien .vdeoamthanh .vdnoidung {
        width: 100% !important;
    }

    #quangtri .vdeoamthanh {
        width: 100% !important;
        display: flex;
        flex-wrap: wrap;
    }

    #quangtri .vdeoamthanh .vdtrai {
        width: 100% !important;
    }

    #quangtri .vdeoamthanh .vdtrai iframe {
        width: 100%;
        margin: 0 auto;
        height: 800px;
        height: 220px;
    }

    #quangtri .vdeoamthanh .vdnoidung {
        width: 100% !important;
        font-size: 18px;
    }
}

@media (max-width: 475px) {
    .card {
        font-size: 0.9em;
    }
}
</style>
